'use strict';

import { components, isDesktop, isMobile, projectMode, settingsData, TRoot } from '../../../settings';
import {
    capitalizeFirstLetter,
    getUrlParam,
    isOptionsCardOpened,
    numberWithCommas,
    RTL_LANGUAGES
} from '../../../functions';
import {rightNavMenuZIndexChange} from "../../menu/navigation/right-nav-bar";
import {closeAsideMenu, getActiveMenuData, setMenuPositionDataAttribute, toggleMenuWidth, updatePagesStyle} from '../../menu/menu';
import {
    changeOptionsCardGalleryDirection,
    renameTowerNameInOptionCard,
    setWidthOfCardDependingOnMenu,
} from '../../cards/optionsCards';
import {CardTypes, ViewMode} from "../../../common";
import { mapUpdate } from '../../widgets/poi/poiv3';
import {applyNow, closeBtnHandler} from "../apply-now/applyNow";
import {applyNowContent} from "../apply-now/applyNowContent";
import {createStreetNames} from "../street-names/addStreetNames";
import {dragUnitCard} from "../../cards/cardsAnimation";
import { updateMapPanoramaInOrbit } from '../../poi/poiCss';
import {recreateBlockWhenLangSwitch} from "../../menu/search/similarSearch";
import {changeUnitCardPosition, closeMultiCards} from "../../cards/unitCards/unitCardFunctions";
import {setCompareButtonPosition} from "../../menu/navigation/compareButton";
import { changeNotiflixNotifyPosition, updateNotiflixNotifyDirection } from '../../analytics/statistic';
import {UnitCardClass} from "../../cards/unitCards/UnitCardClass";
import { BuildingSwitch } from '../building-switch/building_switch';
import { contactFormChangeLanguage } from '../chats/chats';
import {PrivacyAndTerms} from "../../menu/PrivacyAndTerms";
import { CylinderBase } from '../../cylinderGrid/CylinderBase';
import {closeOptionsCard, updateLangTechnicalSpecifications} from "../../cards/cardsFunctions";
import {changePlaceholder, setTranslateToCheckbox, setTranslateToSendBtn} from "../form/form";
import { contactUsChangeLanguage } from '../../menu/contactUs/contactUs';
import {IntersectionLegenda} from "../IntersectionLegenda";
import { updateAboutUsLanguage } from '../../menu/about/aboutv3';
import { Documents } from '../../menu/documents/Documents';
import {Vantages} from "../vantage/Vantage";
import {BaseElement} from "../../interfaces/BaseElement";
import { Cookie } from '../../Cookie/Cookie';
import { Joystick } from '../../controls/Joystick';
import {Amenities} from "../Amenities/Amenities";
import {cylinderFloorNumbers} from "../cylinderFloorNumbers/cylinderFloorNumbers";
import { Objects } from '../../threejs/Objects/Objects';
import { SalesPlane } from "../../threejs/SalesPlane";
import { MultipleSelector } from '../../interfaces/MultipleSelector';

export const langSwitcher = ({languages}) => {
    const languagesArr = languages.map(lang => lang.toLowerCase());
    const currentLang = getCurrentLang();
    changeContentText(currentLang);
    setLocaleFormatForNumbers();

    if (languagesArr.length > 1)
        addLangDropDownList(languagesArr,languages,currentLang);
}

export function langToggleHandler (e) {
    let element;
    if (e.target.classList.contains('lord__icon')){
        element = e.target.closest('.header__lang-toggle').querySelector('.lang-items__list');
    } else {
        element = e.target.firstElementChild;
    }
    setActiveLang(element);
    element.classList.toggle('lang-items__list__hide');
}

function setActiveLang (langContainer) {
    const currentLang = getCurrentLang();
    const activeLang = langContainer.querySelector('.lang__item.lang__active');
    if (currentLang !== activeLang.dataset.lang){
        activeLang.classList.remove('lang__active');
        const newLangElement = langContainer.querySelector('.lang__item[data-lang="'+currentLang+'"]');
        newLangElement.classList.add('lang__active');
    }
}

function addLangDropDownList (langsArr,languages,currentLang) {
    const allToggle = document.querySelectorAll('.header__lang-toggle');
    allToggle.forEach(el =>{
        addLangToMobileMenu(el,langsArr,languages,currentLang);
        el.addEventListener('click',(e) => langToggleHandler(e));
    });
}

function addLangToMobileMenu (container,langsArr,languages,currentLang) {
    const englishFlagNodes = {
        us: `<span class="icon-USA2"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span><span class="path5"></span><span class="path6"></span><span class="path7"></span><span class="path8"></span><span class="path9"></span><span class="path10"></span><span class="path11"></span><span class="path12"></span><span class="path13"></span><span class="path14"></span><span class="path15"></span><span class="path16"></span><span class="path17"></span><span class="path18"></span><span class="path19"></span><span class="path20"></span><span class="path21"></span><span class="path22"></span><span class="path23"></span><span class="path24"></span><span class="path25"></span><span class="path26"></span><span class="path27"></span><span class="path28"></span><span class="path29"></span><span class="path30"></span><span class="path31"></span><span class="path32"></span><span class="path33"></span><span class="path34"></span><span class="path35"></span><span class="path36"></span><span class="path37"></span><span class="path38"></span><span class="path39"></span><span class="path40"></span><span class="path41"></span><span class="path42"></span><span class="path43"></span><span class="path44"></span><span class="path45"></span><span class="path46"></span><span class="path47"></span><span class="path48"></span><span class="path49"></span><span class="path50"></span><span class="path51"></span><span class="path52"></span><span class="path53"></span><span class="path54"></span><span class="path55"></span><span class="path56"></span><span class="path57"></span><span class="path58"></span></span>`,
        uk: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 30">
                <clipPath id="a">
                    <path d="M0 0v30h60V0z"/>
                </clipPath>
                <clipPath id="b">
                    <path d="M30 15h30v15zv15H0zH0V0zV0h30z"/>
                </clipPath>
                <g clip-path="url(#a)">
                    <path d="M0 0v30h60V0z" fill="#012169"/>
                    <path d="M0 0l60 30m0-30L0 30" stroke="#fff" stroke-width="6"/>
                    <path d="M0 0l60 30m0-30L0 30" clip-path="url(#b)" stroke="#C8102E" stroke-width="4"/>
                    <path d="M30 0v30M0 15h60" stroke="#fff" stroke-width="10"/>
                    <path d="M30 0v30M0 15h60" stroke="#C8102E" stroke-width="6"/>
                </g>
            </svg>`,
        ca: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9600 4800">
                <path fill="#d52b1e" d="M0 0h2400l99 99h4602l99-99h2400v4800H7200l-99-99H2499l-99 99H0z"/>
                <path fill="#fff"
          d="M2400 0h4800v4800H2400zm2490 4430l-45-863a95 95 0 01111-98l859 151-116-320a65 65 0 0120-73l941-762-212-99a65 65 0 01-34-79l186-572-542 115a65 65 0 01-73-38l-105-247-423 454a65 65 0 01-111-57l204-1052-327 189a65 65 0 01-91-27l-332-652-332 652a65 65 0 01-91 27l-327-189 204 1052a65 65 0 01-111 57l-423-454-105 247a65 65 0 01-73 38l-542-115 186 572a65 65 0 01-34 79l-212 99 941 762a65 65 0 0120 73l-116 320 859-151a95 95 0 01111 98l-45 863z"/>
            </svg>`
    };

    const languageFlags = [
        {
            lang: 'en',
            text: 'English',
            node: englishFlagNodes[config.features?.languageSwitcher?.flagType?.en || 'us'],
        },
        {
            lang: 'he',
            text: 'Hebrew',
            className: 'icon-Israel2',
            node: `<span class="icon-Israel2"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span></span>`,
        },
        {
            lang: 'ar',
            text: 'Arabic',
            node: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 6"><path fill="#00732f" d="M0 0h12v6H0z"/><path fill="#fff" d="M0 2h12v4H0z"/><path d="M0 4h12v2H0z"/><path fill="red" d="M0 0h3v6H0z"/></svg>
            `,
        },
        {
            lang: 'el',
            text: 'Greek',
            node: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27 18"><path fill="#0D5EAF" d="M0 0h27v18H0z"/><path fill="none" stroke-width="2" stroke="#FFF" d="M5 0v11M0 5h10m0-2h17M10 7h17M0 11h27M0 15h27"/></svg>
            `,
        },
        {
            lang: 'de',
            text: 'German',
            node: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 5 3">
                    <path d="M0 0h5v3H0z"/>
                    <path fill="#D00" d="M0 1h5v2H0z"/>
                    <path fill="#FFCE00" d="M0 2h5v1H0z"/>
                </svg>`,
        },
        {
            lang: 'ru',
            text: 'Russian',
            className: 'icon-Russia2',
            node: `<span class="icon-Russia2"><span class="path1"></span><span class="path2"></span><span class="path3"></span></span>`,
        },
        {
            lang: 'fr',
            text: 'France',
            className: 'icon-fr',
            node: `<span class="icon-fr"><span class="path1"></span><span class="path2"></span><span class="path3"></span></span>`
        },
        {
            lang: 'sp',
            text: 'Spain',
            className: 'icon-spain',
            node: `<span class="icon-spain"><span class="path1"></span><span class="path2"></span><span class="path3"></span>
               <span class="path4"></span><span class="path5"></span><span class="path6"></span><span class="path7"></span>
               <span class="path8"></span><span class="path9"></span><span class="path10"></span><span class="path11"></span>
               <span class="path12"></span><span class="path13"></span><span class="path14"></span><span class="path15"></span>
               <span class="path16"></span><span class="path17"></span><span class="path18"></span><span class="path19"></span>
               <span class="path20"></span><span class="path21"></span><span class="path22"></span><span class="path23"></span>
               <span class="path24"></span><span class="path25"></span><span class="path26"></span><span class="path27"></span>
               <span class="path28"></span><span class="path29"></span><span class="path30"></span><span class="path31"></span>
               <span class="path32"></span><span class="path33"></span><span class="path34"></span><span class="path35"></span>
               <span class="path36"></span><span class="path37"></span><span class="path38"></span><span class="path39"></span>
        </span>`
        }
    ];

    const isNoFlag = config.features?.languageSwitcher?.noFlag;
    const langListItems = new BaseElement('ul')
      .addClass('lang-items__list', isDesktop ? 'lang-items__list__hide' : null, isNoFlag ? 'no-flag' : null)
      .event('click', (e) => mobileLangHandler(e,languages))
      .appendTo(isDesktop ? container : document.getElementsByClassName('aside__language-switcher')[0]);

    langsArr.forEach(lng =>{
        if (!languageFlags.find(item => item.lang === lng))
            return;

        const {lang, node, text} = languageFlags.find(item => item.lang === lng);

        const lngBtn = new BaseElement('li')
          .addClass('lang__item', currentLang === lng ? 'lang__active' : null)
          .setAttributes({
              'data-lang': lng,
              'title': capitalizeFirstLetter(lng)
          })
          .appendTo(langListItems.DOMElement);

        const buttonType = isNoFlag
            ? lang
            : node ? node : lang

        new BaseElement('span')
          .addClass('lang__flag')
          .innerHtml(buttonType)
          .appendTo(lngBtn.DOMElement);

        if (isDesktop && !isNoFlag) {
            new BaseElement('span')
              .addClass('lang__text')
              .innerHtml(text)
              .appendTo(lngBtn.DOMElement)
        }
    });
}

function mobileLangHandler (e,languages) {
    e.stopImmediatePropagation();
    const parent = e.target.closest('.lang__item');
    if (!parent)
        return;
    const languageList = parent.closest('.lang-items__list');
    const lng = languages.find(item => item === parent.dataset.lang);

    if (lng === getCurrentLang())
        return;

    const presentDisclaimer = TRoot.querySelector('.disclaimer__pop-up')
    if (presentDisclaimer)
        presentDisclaimer.remove();

    setDomElementLangChanges(lng, parent);
    changeContentText(lng);
    setLocaleFormatForNumbers();
    changeLangInIframe(lng);
    // headerState(true);

    if (isMobile) {
        closeOptionsCard();
        closeAsideMenu();
        components.mobileSearch?.update('full-update');
    }

    closeMultiCards();

    if (settingsData.activeViewMode === ViewMode.Cylinder && !Vantages.isActive())
        Amenities.show();

    if (isDesktop)
        languageList.classList.add('lang-items__list__hide');
    if (!isMobile)
        toggleMenuWidth({action: 'mini', source: 'orbit'})
}

function changeLangInIframe (lang) {
    const allFrames = document.querySelectorAll('.content__page');
    allFrames.forEach(frame =>{
       const newUrl = new URL(frame.src);
       newUrl.searchParams.set('lang',lang);
       frame.src = newUrl.href;
    });

    if (isMobile && UnitCardClass.findCard()?.html)
        changeUnitCardPosition();
}

// export function setInitialHtmlDirection (settings) {
//     const languagesArr = settings.languages.map(lang => lang.toLowerCase());
//     let currentLang = languagesArr[0];
//
//     if (!getCookie('language')) {
//         const isLangInURL = getUrlParam('lang');
//         if (isLangInURL && languagesArr.includes(isLangInURL)) {
//             currentLang = isLangInURL;
//         } else if (settings.general.defaultLanguage) {
//             const defLanguage = settings.general.defaultLanguage;
//             currentLang = languagesArr.includes(defLanguage) ? defLanguage : languagesArr[0];
//         } else {
//             let userLang = window.navigator.language.toLowerCase().split('-')[0];
//             currentLang = settings.languages.includes(userLang) ? userLang : languagesArr[0];
//         }
//     } else {
//         currentLang = getCookie('language');
//         if (!languagesArr.includes(currentLang)){
//             if (settings.general.defaultLanguage){
//                 const defLanguage = settings.general.defaultLanguage;
//                 currentLang = languagesArr.includes(defLanguage) ? defLanguage : languagesArr[0];
//             } else {
//                 let userLang = window.navigator.language.toLowerCase().split('-')[0];
//                 currentLang = settings.languages.includes(userLang) ? userLang : languagesArr[0];
//             }
//         }
//     }
//
//     const html = document.querySelector('html');
//     html.setAttribute('lang', currentLang);
//     html.setAttribute('dir', (RTL_LANGUAGES.includes(currentLang)) ? 'rtl' : 'ltr');
//     setCookie('language', currentLang, {'max-age': 365 * 2 * 24 * 60 * 60 * 1000});
//
//     return currentLang;
// }

export function setInitialHtmlDirection(settings) {
    const languagesArr = settings.languages.map(lang => lang.toLowerCase());
    const getDefaultLanguage = () => {
        const defLanguage = settings.general.defaultLanguage?.toLowerCase();
        return languagesArr.includes(defLanguage) ? defLanguage : languagesArr[0];
    };

    const getBrowserLanguage = () => {
        let userLang = window.navigator.language.toLowerCase().split('-')[0];
        return languagesArr.includes(userLang) ? userLang : getDefaultLanguage();
    };

    const getCurrentLanguage = () => {
        const urlLang = getUrlParam('lang')?.toLowerCase();
        if (urlLang && languagesArr.includes(urlLang)) return urlLang;

        const cookieLang = Cookie.getCookie('language');
        if (cookieLang) return languagesArr.includes(cookieLang) ? cookieLang : getDefaultLanguage();

        return settings.general.defaultLanguage ? getDefaultLanguage() : getBrowserLanguage();
    };

    const currentLang = getCurrentLanguage();
    document.querySelector('html').setAttribute('lang', currentLang);
    document.querySelector('html').setAttribute('dir', RTL_LANGUAGES.includes(currentLang) ? 'rtl' : 'ltr');
    Cookie.setCookie('language', currentLang, { 'max-age': 365 * 2 * 24 * 60 * 60 * 1000 });
    projectMode.Pagination.query('lang',currentLang);
}

async function setDomElementLangChanges(currentLang, selectedLang) {
    const applyNowBlock =  document.querySelector(`.apply__main-container:not(.chats)`);
    const optionsCard = document.querySelector(`.${CardTypes.Options}-card`);

    settingsData.switchLang = true;
    const html = document.querySelector('html');
    html.setAttribute('lang', currentLang);
    projectMode.Pagination.query('lang',currentLang);
    html.setAttribute('dir', RTL_LANGUAGES.includes(currentLang) ? 'rtl' : 'ltr');
    Cookie.setCookie('language', currentLang, {'max-age': 365 * 2 * 24 * 60 * 60 * 1000});

    const langContainer = selectedLang.parentElement;
    const activeLang = langContainer.querySelector('.lang__item.lang__active');
    activeLang.classList.remove('lang__active');
    selectedLang.classList.add('lang__active');
    updatePagesStyle();

    BuildingSwitch.changeLanguage();
    // changeSearchModulePosition();
    contactFormChangeLanguage();

    const formContainerMainElement = document.querySelector('.form__container-main');
    changePlaceholder(formContainerMainElement);
    setTranslateToCheckbox(formContainerMainElement);
    setTranslateToSendBtn(formContainerMainElement);
    mapUpdate();
    updateAboutUsLanguage();
    updateMapPanoramaInOrbit();
    PrivacyAndTerms.updateItems();
    !isMobile && createStreetNames();
    !isMobile && cylinderFloorNumbers();
    contactUsChangeLanguage();
    Documents.changeLanguage();
    SalesPlane.scope?.changeLanguage();
    setMenuPositionDataAttribute();
    CylinderBase.changeLanguage();
    Objects.translate();
    IntersectionLegenda.build();
    Joystick.updatePosition();
    MultipleSelector.refresh();
    if (!isMobile) {
        changeUnitCardPosition();

        setTimeout(() => {
            dragUnitCard();
        }, 200);

        if (applyNowBlock) {
            closeBtnHandler();
            applyNow(document.body, applyNowContent, false, ['print-btn', 'popup-btn.icon-close'], settingsData.lastClickedFlat);
        }
    }

    updateLangTechnicalSpecifications();

    if (optionsCard) {
        setWidthOfCardDependingOnMenu();
        recreateBlockWhenLangSwitch();
        changeOptionsCardGalleryDirection();
        renameTowerNameInOptionCard();
        changeNotiflixNotifyPosition();
        Vantages.scopes.forEach(scope => scope.viewer.calculateViewport());
    }else {
        updateNotiflixNotifyDirection();
    }

    UnitCardClass.changeTowerNameWhenLanguageSwitching();

    const compareCards = document.querySelector(`.compare-block`);
    if (compareCards) {
        setWidthOfCardDependingOnMenu(compareCards);
    }

    const compareButton = document.querySelector('.compare-button');
    compareButton && setCompareButtonPosition(compareButton);

}

function changeContentText(currentLang) {
    const textNodes = document.querySelectorAll('.language-string');
    textNodes.forEach(item => {
        if (item.getAttribute('data-dictionary')) {
            if (item.classList.contains('flat-label--subtitle')){
                item.innerHTML = changeLangToCurrent(item.getAttribute('data-dictionary'));
            } else {
                if (item.getAttribute('data-dictionary-param')) {
                    const param = item.getAttribute('data-dictionary-param');
                    item.setAttribute(param, changeLangToCurrent(item.getAttribute('data-dictionary')));
                } else {
                    item.innerHTML = changeLangToCurrent(item.getAttribute('data-dictionary'));
                }
            }
        } else if (item.getAttribute('data-lang-en')) {
            if (item.getAttribute(`data-lang-${getCurrentLang()}`)) {
                item.innerHTML = item.getAttribute(`data-lang-${getCurrentLang()}`);
            } else {
                item.innerHTML = item.getAttribute(`data-lang-en`);
            }
        } else if (item.getAttribute('data-dictionary-parse')) {
            const [number, word] = item.textContent.split(' ');
            const text = changeLangToCurrent(item.getAttribute('data-dictionary-parse'));
            item.innerHTML = `${number} ${text}`;
        } else if (item.getAttribute('data-lord-lang')) {
            item.lastChild.innerHTML = changeLangToCurrent(item.getAttribute('data-lord-lang'));
        } else {
            item.innerHTML = item.getAttribute(`data-${currentLang.toLowerCase()}`);
        }
    });
}

function setLocaleFormatForNumbers() {
    const markedNumberElements = document.querySelectorAll('.translate-number');
    markedNumberElements.forEach(element => {
        const isPrice = element.classList.contains('price');
        element.innerText = numberWithCommas(element.innerText, isPrice);
    });
}

export function getCurrentLang() {
    return document.querySelector('html').getAttribute('lang');
}

export function getCurrentLangDirection () {
    return document.querySelector('html').getAttribute('dir');
}

export function changeLangToCurrent(word,replaceArray) {
    if (config.dictionary && config.dictionary[word]) {
        if (replaceArray && replaceArray.length) {
            replaceArray.forEach(obj => {
                Object.entries(obj).forEach(([key,value]) => {
                    const regExp = new RegExp(`{{${key}}}`, 'g');
                    Object.entries(value).forEach(([lang,value]) => {
                        config.dictionary[word][lang] = config.dictionary[word][lang].replace(regExp,value);
                    });
                });
            });
        }

        if (config.dictionary[word][getCurrentLang()]) {
            return config.dictionary[word][getCurrentLang()] === '__empty__' ? '' : config.dictionary[word][getCurrentLang()];
        } else if (config.dictionary[word]['en']) {
            return config.dictionary[word]['en'];
        } else if (ld[0]?.defaultLanguage && config.dictionary[word][ld[0]?.defaultLanguage]) {
            return config.dictionary[word][ld[0]?.defaultLanguage];
        }

        const anyExistedTranslation = getTranslationFromExisted(config.crmProjectSettings.languages, config.dictionary[word]);
        if (anyExistedTranslation)
            return anyExistedTranslation;
    }

    return word === '__empty__' ? '' : word;
}

function getTranslationFromExisted(languages, translations) {
    for (const lang of languages) {
        if (translations[lang]) {
            return translations[lang];
        }
    }

    return Object.values(translations).find(Boolean) || '';
}

export function getLanguagesTranslations (key) {
    const data = {};
    
    const dictionary = config.dictionary[key];
    const projectLanguages = config.crmProjectSettings.languages;
    
    for (let i = 0; i < projectLanguages.length; i++) {
        const lang = projectLanguages[i];
        let translate = dictionary[lang];
        if (!translate) {
            translate = dictionary['en'];
        }
        
        data[lang] = translate;
    }
    
    return data;
}
